module.exports = __webpack_public_path__ + "static/media/doctor-image.05671e08.png";